import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DateQuestion } from '@interfaces/questions';
import { WorkflowItemKeyDirective } from '@workflow/directives/workflow-item-key/workflow-item-key.directive';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { UnsubscribeOnDestroy } from '@app/util/lifecycle-hooks/lifecycle-hooks';

@Component({
	selector: 'workflow-date-question',
	templateUrl: './date-question.component.html',
	styleUrls: ['./date-question.component.scss'],
})
export class DateQuestionComponent {
	@UnsubscribeOnDestroy
	private readonly subscription = new Subscription();
	
	@Input() question?: DateQuestion;
	@Input() isWizard = false;
	@Input() finishedAndLocked = false;
	@Input() isLocked = false;
	
	@Output() valid: EventEmitter<boolean> = new EventEmitter();
	
	public readonly initialDate = new Date();
	
	public readonly value$: Observable<Date | null>;
	
	constructor(private readonly workflowItemKey: WorkflowItemKeyDirective) {
		this.value$ = workflowItemKey.property$
			.pipe(
				map(value => {
					if (typeof value === 'string' || typeof value === 'number') {
						return new Date(value);
					} else if (value instanceof Date) {
						return value;
					} else {
						return null;
					}
				}),
			);
	}
	
	public setValue(value: Date | null): void {
		if (value === null || value instanceof Date) {
			this.workflowItemKey.setProperty(value);
		} else {
			throw new TypeError('value is not of Type Date');
		}
	}
}
